// Static demo-mode fill-in data for DashboardOverviewNew.component.jsx (User
// Dashboard). Shapes must match exactly what each card component expects —
// see src/views/DashboardOverviewNew/components/*. Department Dashboard
// (TeamDashboard) renders the identical set of card components, so most
// exports here are re-used verbatim from its demo data rather than
// duplicated — the shapes are per-component, not per-page.

// Already shaped for the individual (per-user) dashboard — these were
// staged in dashboardOverviewNew.data.js as a template/shape-source for
// DashboardOverviewNew.helpers.js's builders, but never gated by IS_DEMO.
export {
  OVERALL_PRODUCTIVITY_DATA as DEMO_OVERALL_PRODUCTIVITY_DATA,
  KEY_HIGHLIGHTS_DATA as DEMO_KEY_HIGHLIGHTS_DATA,
} from './data/dashboardOverviewNew.data';

// Re-exported from Department Dashboard's demo data where there's no
// per-user figure to contradict — identical card components render both
// views, and these three are department-wide by nature (a comparison
// line/heatmap/alert feed), not a per-user total that needs to reconcile
// with DEMO_KEY_HIGHLIGHTS_DATA above.
export {
  DEMO_PRODUCTIVITY_OVER_TIME_DATA,
  DEMO_CHART_TICKS,
  DEMO_ACTIVITY_HEATMAP_DATA,
  DEMO_RECENT_ALERTS_DATA,
} from '../TeamDashboard/TeamDashboard.demoData';

// These four, unlike the ones above, each show a per-user "total" that must
// reconcile with DEMO_KEY_HIGHLIGHTS_DATA's Active Time (6h32m/392min),
// Focus Time (3h48m/228min), and Attendance (27/28) — so they're defined
// here against Ryan Mitchell's own numbers instead of reusing Department
// Dashboard's (which are the 5-person team's aggregate, not his).

// Consumed by ActivityBreakdown (via DonutCard): segments' `value` is a
// percent (0-100) of `totalTime`, which equals Active Time above.
export const DEMO_ACTIVITY_BREAKDOWN_DATA = {
  totalTime: '6h 32m',
  label: 'Total Tracked',
  segments: [
    { name: 'Productive', value: 65, color: '#4F7EF8' },
    { name: 'Meetings', value: 15, color: '#a78bfa' },
    { name: 'Breaks', value: 12, color: '#f59e0b' },
    { name: 'Idle', value: 8, color: '#E5E7EB' },
  ],
};

// Consumed by TopApplications: each `pct` is that app's own time as a
// percent of Active Time (392min) — needn't sum to 100 (apps can overlap).
export const DEMO_TOP_APPLICATIONS_DATA = [
  { name: 'Visual Studio Code', time: '2h 45m', pct: 42, color: '#4F7EF8' },
  { name: 'Google Chrome', time: '1h 52m', pct: 29, color: '#22c55e' },
  { name: 'Slack', time: '58m', pct: 15, color: '#7a5af8' },
  { name: 'Figma', time: '45m', pct: 11, color: '#f59e0b' },
  { name: 'Terminal', time: '38m', pct: 10, color: '#ef4444' },
];

// Consumed by FocusVsDistraction (via DonutCard): Focus time/pct must match
// DEMO_KEY_HIGHLIGHTS_DATA's Focus Time card (3h48m, 58% of Active Time)
// exactly — Distraction is simply Active Time minus Focus.
export const DEMO_FOCUS_VS_DISTRACTION_DATA = {
  focusPct: 58,
  label: 'Focused',
  segments: [
    { name: 'Focus', pct: 58, time: '3h 48m', color: '#4F7EF8' },
    { name: 'Distraction', pct: 42, time: '2h 44m', color: '#f59e0b' },
  ],
};

// Consumed by AttendanceSummary (via DonutCard): must match
// DEMO_KEY_HIGHLIGHTS_DATA's Attendance card (27/28 present = 96%).
export const DEMO_ATTENDANCE_SUMMARY_DATA = {
  overall: 96,
  segments: [
    { name: 'Present', value: 96, color: '#22c55e' },
    { name: 'Absent', value: 4, color: '#E5E7EB' },
  ],
};

// Consumed by the navbar-slot member Dropdown — only User Dashboard (not
// Department Dashboard) has a member picker. Shape matches
// useMembersOptionsForSelect's membersOptions: {value, label, employeeId, rate}.
export const DEMO_MEMBERS_OPTIONS = [
  {
    value: 'demo-user',
    label: 'Ryan Mitchell (EMP-1001)',
    employeeId: 'EMP-1001',
    rate: 55,
  },
  {
    value: 'demo-emp-1',
    label: 'Rachel Turner (EMP-1002)',
    employeeId: 'EMP-1002',
    rate: 50,
  },
  {
    value: 'demo-emp-2',
    label: 'Michael Chen (EMP-1003)',
    employeeId: 'EMP-1003',
    rate: 42,
  },
  {
    value: 'demo-emp-3',
    label: 'Sarah Johnson (EMP-1004)',
    employeeId: 'EMP-1004',
    rate: 38,
  },
];

export const DEMO_SELECTED_MEMBER = DEMO_MEMBERS_OPTIONS[0];
